import { createModal } from "@commonlibs";
import TabsModal from "ui/common/components/feedback/TabsModal/TabsModal";
import { TabsModalProps } from "ui/common/components/feedback/TabsModal/TabsModal.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import clsx from "clsx";
import { UpdateTermsAndPrivacyState } from "./UpdateTermsAndPrivacyModal.types";
import UploadTermsAndPrivacyTab from "./UploadTermsAndPrivacyTab";
import ConfirmUpdateTermsAndPrivacyTab from "./ConfirmUpdateTermsAndPrivacyTab";

export interface UpdateTermsAndPrivacyModalProps extends Omit<TabsModalProps<UpdateTermsAndPrivacyState>, "tabs" | "title"> {
    className?: string;
    style?: React.CSSProperties;
}

const UPDATE_TERMS_AND_PIVACY_TABS = [{ content: <UploadTermsAndPrivacyTab /> }, { content: <ConfirmUpdateTermsAndPrivacyTab /> }];

const UpdateTermsAndPrivacyModal = createModal(({ className, ...rest }: UpdateTermsAndPrivacyModalProps) => {
    const translate = useTranslate();

    return (
        <TabsModal
            title={translate("updateTermsAndPrivacyTitle")}
            tabs={UPDATE_TERMS_AND_PIVACY_TABS}
            className={clsx("update-terms-privacy-modal", className)}
            {...rest}
        />
    );
});

export default UpdateTermsAndPrivacyModal;
